<template>
  <div class="upgrade">
    <div class="slide">
      <mySlide />
    </div>
    <div class="upgrade-top">
      <div class="w1500">
        <div class="back-box-w  flex flex-ac flex-jsb">
          <div></div>
          <div class="voice-cart-box flex-0 flex flex-ac">
            <div class="voice-item flex flex-ac" :class="{'voice-item-active':cartState}">
              <el-switch v-model="cartState" active-color="#FFC400" inactive-color="#BBB9B9" @change="cartStateChange">
              </el-switch>
              <div class="t">动画</div>
            </div>
            <div class="voice-item flex flex-ac" :class="{'voice-item-active':voiceState}">
              <el-switch v-model="voiceState" active-color="#FFC400" inactive-color="#BBB9B9" @change="voiceStateChange">
              </el-switch>
              <div class="t">音效</div>
            </div>
            <div class="voice-item flex flex-ac" @click="$refs['RulePopup'].toggle('Upgrade')">
              <div class="gui-bo flex flex-ac flex-jc">
                <i class="el-icon-s-order"></i>
              </div>
              <div class="t">规则</div>
            </div>
          </div>
        </div>
        <div class="upgrade-skin">
          <div class="upgrade-skin-pc flex flex-ac flex-jsb">
            <div class="sel-skin">
              <div class="skin-bg">
                <img src="@/assets/images/upgrade/skin-bg.png" alt="" class="skin-bg-img" srcset="">
                <div v-show="setData.pack_id!=''" class="img-box flex flex-jc flex-ac">
                  <img :src="setData.pack_data.img" alt="" class="skin-img" srcset="">
                </div>
                <div v-if="setData.pack_id==''" class="arrow-loop-container jTBQPZ jTBQPB" @click="goPage('pack')">
                  <!-- <img src="@/assets/images/upgrade/arrow-mid-C1xhyQjy.webp" alt="" class="skin-bg-img" srcset=""> -->
                  <div class="arrow-icon"></div>
                  <div class="arrow-icon"></div>
                  <div class="arrow-icon"></div>
                </div>
              </div>
              <div class="text">选择仓库饰品</div>
            </div>
            <div class="kedu">
              <div class="kedu-bg">
                <img src="@/assets/images/upgrade/ke-pan.png" alt="" srcset="" class="ke-pan">
                <div class="ke-pan-div">
                  <!-- <div class="line-img"></div> -->
                  <img src="@/assets/images/upgrade/ke-zhen.png" alt="" srcset="" class="line-img" :style="'transform: rotate('+(3.6 * setData.probability)+'deg);'">
                  <div class="rate-p">{{ setData.probability }}%</div>
                </div>
              </div>
              <div class="rate">风险概率</div>
              <!-- <div class="btn">升级物品</div> -->
            </div>
            <div class="sel-skin">
              <div class="skin-bg">
                <img src="@/assets/images/upgrade/skin-bg.png" alt="" class="skin-bg-img" srcset="">
                <div v-show="setData.lucky_id!=''" class="img-box flex flex-jc flex-ac">
                  <img :src="setData.lucky_data.imageUrl" alt="" class="skin-img" srcset="">
                </div>
                <div v-if="setData.lucky_id==''" class="arrow-loop-container jTBQPZ" @click="goPage('lucky')">
                  <!-- <img src="@/assets/images/upgrade/arrow-mid-C1xhyQjy.webp" alt="" class="skin-bg-img" srcset=""> -->
                  <div class="arrow-icon"></div>
                  <div class="arrow-icon"></div>
                  <div class="arrow-icon"></div>
                </div>
              </div>
              <div class="text">选择你想升级的饰品</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="el-slider-w">
      <div class="w1500">
        <div class="el-slider-box flex flex-jsb flex-ac">
          <div class="slide-left">
            <el-slider v-model="setData.probability" :marks="marks" :min="probability_min" :max="probability_max" :show-tooltip="false" @change="handleChangeSlider"></el-slider>
            <div class="valText" :style="'left:'+setData.probability+'%'">{{ setData.probability }} %</div>
          </div>
          <div class="btn-w-r-bg" @click="handleUpgrade">
            <div class="btn-c-r" v-if="jisPrice() > 0">
              <span>支付 {{ jisPrice() }} 立即升级</span>
            </div>
            <div class="btn-c-r" v-else>
              <span>立即升级</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="upgrade-content">
      <div class="csgo-title">
        <div class="flex flex-ac flex-jc">
          <img src="@/assets/images/title-label.png" />
          <div class="t">立即升级你的饰品</div>
          <img src="@/assets/images/title-label.png" />
        </div>
      </div>
      <!-- 这个是pc的样式 -->
      <div class="w1500 warehouse-box-pc" ref="warehouse-box-pc" style="padding-bottom: 30px;">
        <div class="warehouse-box flex flex-jsb">
          <!-- 背包饰品 -->
          <div class="warehouse-accessories">
            <div class="title flex flex-ac flex-jsb">
              <div class="t">仓库饰品</div>
              <div class="sel-form">
                <div class="sel-form-item" @click="packPrceChange('searchForm')">
                  <span>价格</span>
                  <i :class="searchForm.sort_value=='desc'?'el-icon-caret-bottom':'el-icon-caret-top'"></i>
                </div>
              </div>
            </div>
            <div class="acessories-box">
              <div v-if="packList.length==0" class="no-data flex flex-jc flex-ac">
                <div>
                  <img src="@/assets/images/roll/no-data.png" alt="" srcset="">
                  <div class="text">您目前仍无可用饰品~</div>
                  <div class="des">开箱即可获得物品~</div>
                  <div class="btn" @click="goIndex">立即开箱</div>
                </div>
              </div>
              <div v-else>
                <div class="revisionSkin">
                  <ul>
                    <li v-for="item in packList" :key="item.id" class="skin-li" :class="parseColor(item)">
                      <div class="li-div">
                        <span class="ico">{{ item.exteriorName }}</span>
                        <div class="bei">
                          <img :src="item.img" class="img_active" />
                        </div>
                        <div class="name name-line2 p-2">{{ item.name }}</div>
                        <div class="money-warp">
                          <img src="@/assets/images/money.png" class="money-img" />
                          <span>{{ item.price }}</span>
                        </div>
                        <div class="color-line" :style="'background-color:'+parseColor(item,'','color')"></div>
                        <div class="skin-item-sel" :class="{'skin-item-sel-ed':setData.pack_id==item.id}" @click="handleSkin(item,'pack')">
                          <i v-show="setData.pack_id==item.id" class="iconfont icon-dg check-ed"></i>
                          <div v-show="setData.pack_id!=item.id" class="plus-ass">
                            <i class="el-icon-plus"></i>
                          </div>
                          <div v-show="setData.pack_id==item.id" class="plus-ass plus-ass-d">
                            <i class="el-icon-close"></i>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="csgo-page">
                  <el-pagination background layout="prev, pager, next" :pager-count="5" :current-page.sync="searchForm.page" :total="searchForm.totalSize" :page-size="searchForm.limit" @current-change="currentChange">
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
          <!-- 幸运饰品 -->
          <div class="warehouse-accessories">
            <div class="title flex flex-ac flex-jsb">
              <div class="t">目标饰品</div>
              <div class="sel-form">
                <el-input v-model="luckyForm.searchKey" placeholder="搜索" class="sel-form-input" @input="handleLucky">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-select v-model="luckyForm.rarity" class="sel-form-select" placeholder="请选择" @change="handleCommand">
                  <el-option v-for="item in rarityList" :key="item.key" :label="item.title" :value="item.key"></el-option>
                </el-select>
                <div class="sel-form-item" @click="packPrceChange('luckyForm')">
                  <span>价格</span>
                  <i :class="luckyForm.sort=='desc'?'el-icon-caret-bottom':'el-icon-caret-top'"></i>
                </div>
              </div>
            </div>
            <div class="acessories-box">
              <div v-if="luckyList.length==0" class="no-data flex flex-jc flex-ac">
                <div>
                  <img src="@/assets/images/roll/no-data.png" alt="" srcset="">
                  <div class="text">暂无饰品~</div>
                </div>
              </div>
              <div v-else>
                <div class="revisionSkin">
                  <ul>
                    <li v-for="item in luckyList" :key="item.id" class="skin-li" :class="parseColor(item)">
                      <div class="li-div">
                        <span class="ico">{{ item.exteriorName }}</span>
                        <span class="rate" v-if="item.probability">{{ item.probability }} %</span>
                        <div class="bei">
                          <img :src="item.imageUrl" class="img_active" />
                        </div>
                        <div class="name name-line2 p-2">{{ item.itemName }}</div>
                        <div class="money-warp">
                          <img src="@/assets/images/money.png" class="money-img" />
                          <span>{{ item.price }}</span>
                        </div>
                        <div class="color-line" :style="'background-color:'+parseColor(item,'','color')"></div>
                        <div class="skin-item-sel" :class="{'skin-item-sel-ed':setData.lucky_id==item.id}" @click="handleSkin(item,'lucky')">
                          <i v-show="setData.lucky_id==item.id" class="iconfont icon-dg check-ed"></i>
                          <div v-show="setData.lucky_id!=item.id" class="plus-ass">
                            <i class="el-icon-plus"></i>
                          </div>
                          <div v-show="setData.lucky_id==item.id" class="plus-ass plus-ass-d">
                            <i class="el-icon-close"></i>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="csgo-page">
                  <el-pagination background layout="prev, pager, next" :pager-count="5" :current-page.sync="luckyForm.page" :total="luckyForm.totalSize" :page-size="luckyForm.limit" @current-change="luckCurrentChange">
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w1500 warehouse-box-mobile" ref="warehouse-box-mobile" style="margin-bottom: 30px;">
        <div class="warehouse-box flex flex-jsb">
          <div class="warehouse-accessories flex-1">
            <div class="title flex flex-ac flex-jsb">
              <div class="title-wrap flex flex-0">
                <div class="title-item" :class="{'active-t':setData.showType=='pack'}" @click="setData.showType='pack'">仓库饰品
                </div>
                <div class="title-item" :class="{'active-t':setData.showType=='lucky'}" @click="setData.showType='lucky'">目标饰品
                </div>
              </div>
              <template>
                <div v-show="setData.showType=='pack'" class="sel-form">
                  <div class="sel-form-item" @click="packPrceChange('searchForm')">
                    <span>价格</span>
                    <i :class="searchForm.sort_value=='desc'?'el-icon-caret-bottom':'el-icon-caret-top'"></i>
                  </div>
                </div>
                <div v-show="setData.showType!='pack'" class="sel-form sel-form-pc">
                  <el-input v-model="luckyForm.searchKey" placeholder="搜索" class="sel-form-input" @input="handleLucky">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                  <el-select v-model="luckyForm.rarity" class="sel-form-select" placeholder="请选择" @change="handleCommand">
                    <el-option v-for="item in rarityList" :key="item.key" :label="item.title" :value="item.key"></el-option>
                  </el-select>
                  <div class="sel-form-item" @click="packPrceChange('luckyForm')">
                    <span>价格</span>
                    <i :class="luckyForm.sort=='desc'?'el-icon-caret-bottom':'el-icon-caret-top'"></i>
                  </div>
                </div>
              </template>
            </div>
            <div v-show="setData.showType=='pack'" class="acessories-box">
              <div v-if="packList.length==0" class="no-data flex flex-jc flex-ac">
                <div>
                  <img src="@/assets/images/roll/no-data.png" alt="" srcset="">
                  <div class="text">您目前仍无可用物品~</div>
                  <div class="des">开箱即可获得物品~</div>
                  <div class="btn" @click="goIndex">立即开箱</div>
                </div>
              </div>
              <div v-else>
                <div class="revisionSkin">
                  <ul>
                    <li v-for="item in packList" :key="item.id" class="skin-li" :class="parseColor(item)">
                      <div class="li-div">
                        <span class="ico">{{ item.exteriorName }}</span>
                        <div class="bei">
                          <img :src="item.img" class="img_active" />
                        </div>
                        <div class="name name-line2 p-2">{{ item.name }}</div>
                        <div class="money-warp">
                          <img src="@/assets/images/money.png" class="money-img" />
                          <span>{{ item.price }}</span>
                        </div>
                        <div class="color-line" :style="'background-color:'+parseColor(item,'','color')"></div>
                        <div class="skin-item-sel" :class="{'skin-item-sel-ed':setData.pack_id==item.id}" @click="handleSkin(item,'pack')">
                          <i v-show="setData.pack_id==item.id" class="iconfont icon-dg check-ed"></i>
                          <div v-show="setData.pack_id!=item.id" class="plus-ass">
                            <i class="el-icon-plus"></i>
                          </div>
                          <div v-show="setData.pack_id==item.id" class="plus-ass plus-ass-d">
                            <i class="el-icon-close"></i>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="csgo-page">
                  <el-pagination background layout="prev, pager, next" :pager-count="5" :current-page.sync="searchForm.page" :total="searchForm.totalSize" :page-size="searchForm.limit" @current-change="currentChange">
                  </el-pagination>
                </div>
              </div>
            </div>
            <div v-show="setData.showType=='lucky'" class="acessories-box">
              <div class="sel-form sel-form-mobile">
                <el-input v-model="luckyForm.searchKey" placeholder="搜索" class="sel-form-input" @input="handleLucky">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-select v-model="luckyForm.rarity" class="sel-form-select" placeholder="请选择" @change="handleCommand">
                  <el-option v-for="item in rarityList" :key="item.key" :label="item.title" :value="item.key"></el-option>
                </el-select>
                <div class="sel-form-item" @click="packPrceChange('luckyForm')">
                  <span>价格</span>
                  <i :class="luckyForm.sort=='desc'?'el-icon-caret-bottom':'el-icon-caret-top'"></i>
                </div>
              </div>
              <div v-if="luckyList.length==0" class="no-data flex flex-jc flex-ac">
                <div>
                  <img src="@/assets/images/roll/no-data.png" alt="" srcset="">
                  <div class="text">暂无饰品~</div>
                </div>
              </div>
              <div v-else>
                <div class="revisionSkin">
                  <ul>
                    <li v-for="item in luckyList" :key="item.id" class="skin-li" :class="parseColor(item)">
                      <div class="li-div">
                        <span class="ico">{{ item.exteriorName }}</span>
                        <span class="rate" v-if="item.probability > 0">{{ item.probability }}%</span>
                        <div class="bei">
                          <img :src="item.imageUrl" class="img_active" />
                        </div>
                        <div class="name name-line2 p-2">{{ item.itemName }}</div>
                        <div class="money-warp">
                          <img src="@/assets/images/money.png" class="money-img" />
                          <span>{{ item.price }}</span>
                        </div>
                        <div class="color-line" :style="'background-color:'+parseColor(item,'','color')"></div>
                        <div class="skin-item-sel" :class="{'skin-item-sel-ed':setData.lucky_id==item.id}" @click="handleSkin(item,'lucky')">
                          <i v-show="setData.lucky_id==item.id" class="iconfont icon-dg check-ed"></i>
                          <div v-show="setData.lucky_id!=item.id" class="plus-ass">
                            <i class="el-icon-plus"></i>
                          </div>
                          <div v-show="setData.lucky_id==item.id" class="plus-ass plus-ass-d">
                            <i class="el-icon-close"></i>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="csgo-page">
                  <el-pagination background layout="prev, pager, next" :pager-count="5" :current-page.sync="luckyForm.page" :total="luckyForm.totalSize" :page-size="luckyForm.limit" @current-change="luckCurrentChange">
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 动画弹窗 -->
    <div class="kai-box-open csgo-mask flex flex-ac flex-jc" v-if="isStartCart">
      <div class="kai-warp-box">
        <div class="open-line" ref="openLine"></div>
        <div class="kaibox-warp">
          <div class="kaibox-item">
            <ul class="kaibox-ul0" :class="[isStartCart&&isThree ? 'ul2' :'',isStartCart&&!isThree ? 'ul1' :'']">
              <li v-for="(item, index) in openAnimList" :key="index" class="flex-0 flex flex-ac flex-jc">
                <img :src="item.imageUrl" class="kaibox-img" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--中奖完成后盒子-->
    <div v-if="showWinState">
      <mywin :winList="winList" :winState="showWinState" :winStatus="winStatus" @winexchange="winexchange($event)" @winget="winexchange($event)" @winX="winexchange($event)"></mywin>
    </div>
    <audio controls ref="notify4" class="audio" @play="onPlay" @error="handleAudioError">
      <source src="@/assets/audio/open_box6s.mp3" />
    </audio>
    <audio controls ref="notify" class="audio">
      <source src="@/assets/audio/open_box2.mp3" />
    </audio>
    <myhomebot></myhomebot>
    <div class="commonBg"></div>
    <RulePopup ref="RulePopup" />
  </div>
</template>

<script>
import mywin from "@/components/my_win.vue";
import RulePopup from "@/components/rule-popup.vue"
import myhomebot from "@/components/my_homebot.vue";
import mySlide from "@/g-components/my_slide.vue";
import { parseColor } from "@/assets/js/util.js";
import deepClone from "@/assets/js/deepClone.js";

export default {
  components: { mywin, myhomebot, mySlide, RulePopup },
  data() {
    return {
      parseColor,
      searchForm: {
        page: 1,
        totalSize: 0,
        limit: 12,
        sort_field: 'ps.price',
        sort_value: 'desc'
      },
      packList: [],
      luckyForm: {
        recommend: '',
        new: '',
        type_id: '',
        subclass_id: '',
        rarity: '',
        rarity_name: '不限品质',
        sort: 'asc',
        searchKey: '',
        page: 1,
        totalSize: 0,
        limit: 12
      },
      luckyListY: [],
      tempList: [],
      luckyList: [],
      voiceState: true,
      cartState: true,
      noWin: {
        name: "赠品",
        price: "0.01",
        img: require("@/assets/images/moneyback.png"),
        imageUrl: require("@/assets/images/moneyback.png"),
        class: "img-class",
        back: require("@/assets/img/box-skins-white.png"),
      },
      setData: {
        price: 0,
        p_price: 0,
        probability: 5,
        pack_id: '',
        pack_data: {},
        lucky_id: '',
        lucky_data: {},
        showType: 'pack'
      },
      loading: false,
      showWinState: false,
      winStatus: 2,
      isStartCart: false,
      winList: [],
      rarityList: [],
      totalPrice: 0,
      probability_min: 1,
      probability_max: 100,
      openAnimList: [],
      isThree: false,
      marks: {
        0: '0',
        10: '10',
        20: '20',
        30: '30',
        40: '40',
        50: '50',
        60: '60',
        70: '70',
        80: '80',
        90: '70',
        100: '100'
      }
    };
  },
  watch: {},
  created() {
    this.voiceState = this.$store.state.voiceState
    this.cartState = this.$store.state.cartState
    this.getRarity()
    this.getLucky()
    this.getPackList()
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    // 滑块动作，要限制最少5
    handleChangeSlider(e) {
      if (e < 5) {
        this.setData.probability = 5
      }
      if (e > 75) {
        this.setData.probability = 75
      }
    },
    formatTooltip(val) {
      return val + '%'
    },
    //分页
    currentChange(val) {
      this.searchForm.page = val
      this.getPackList()
    },
    //背包数据
    getPackList() {
      this.$doGet('/api/member.SkinBackpack/list', this.searchForm).then((res) => {
        this.searchForm.totalSize = res.data.count
        this.packList = res.data.list
      }).catch(() => {
      })
    },
    // 价格
    packPrceChange(type) {
      if (type == 'searchForm') {
        this.searchForm.sort_value = this.searchForm.sort_value == 'desc' ? 'asc' : 'desc'
        this.searchForm.page = 1
        this.getPackList()
      } else {
        this.luckyForm.sort = this.luckyForm.sort == 'desc' ? 'asc' : 'desc'
        this.luckyForm.page = 1
        this.handleSearchLucky()
      }
    },
    handleLucky() {
      this.luckyForm.page = 1
      this.handleSearchLucky()
    },
    handleCommand(e) {
      this.luckyForm.page = 1
      this.handleSearchLucky()
    },
    // 前端筛选幸运饰品的方法
    handleSearchLucky() {
      // 价格
      let tempList = deepClone(this.luckyListY)
      tempList = tempList.sort((a, b) => {
        if (this.luckyForm.sort == 'desc') {
          return b.price - a.price
        } else {
          return a.price - b.price
        }
      })
      if (this.luckyForm.rarity) {
        tempList = tempList.filter((item) => {
          return item.rarity == this.luckyForm.rarity
        })
      }
      if (this.luckyForm.searchKey) {
        tempList = tempList.filter((item) => {
          return item.itemName.indexOf(this.luckyForm.searchKey) != -1
        })
      }
      // 这边是对价格的控制
      let sum = 0, rate = 1
      tempList = tempList.filter(item => {
        rate = item.price >= 100 ? 0.5 : 0.65
        sum = this.setData.p_price / rate
        item.probability = this.setData.p_price ? Math.round((this.setData.p_price / item.price > rate ? rate : this.setData.p_price / item.price) * 100) : 0
        return item.price > sum
      })
      this.tempList = deepClone(tempList)
      this.luckyForm.totalSize = this.tempList.length
      this.luckyList = tempList.slice((this.luckyForm.page - 1) * this.luckyForm.limit, this.luckyForm.page * this.luckyForm.limit)
    },
    // 这边是幸运饰品的东西
    luckCurrentChange(val) {
      this.luckyForm.page = val
      let tempList = deepClone(this.tempList)
      this.luckyList = tempList.slice((this.luckyForm.page - 1) * this.luckyForm.limit, this.luckyForm.page * this.luckyForm.limit)
      // this.getLucky()
    },
    getLucky() {
      this.$doGet("/api/hall.LuckySkin/list", {
        recommend: '',
        new: '',
        type_id: '',
        subclass_id: '',
        rarity: '',
        rarity_name: '不限品质',
        sort: 'asc',
        searchKey: '',
        page: 1,
        totalSize: 0,
        limit: 99999
      }).then((res) => {
        this.luckyForm.totalSize = res.data.count
        this.luckyListY = res.data.list
        this.tempList = deepClone(this.luckyListY)
        let tempList = deepClone(this.tempList)
        this.luckyList = tempList.slice((this.luckyForm.page - 1) * this.luckyForm.limit, this.luckyForm.page * this.luckyForm.limit)
        // 这个是从我的那边过来的
        if (this.$route.query.id) {
          let upgradeData = localStorage.getItem("upgradeData")
          if (upgradeData) {
            let tempdata = JSON.parse(upgradeData)
            if (tempdata.id == this.$route.query.id) {
              this.handleSkin(tempdata, 'pack')
            }
          }
        }
      }).catch(() => { })
    },
    // 获取品质
    getRarity() {
      this.$doGet("/api/setting.Setting/getRarity").then((res) => {
        this.rarityList = res.data
      }).catch(() => {
      })
    },
    goIndex() {
      this.$router.push({
        path: '/index'
      });
    },
    voiceStateChange(e) {
      this.$store.commit("getVoiceState", e)
    },
    cartStateChange(e) {
      this.$store.commit("getCartState", e)
    },
    // 这个是选择饰品
    handleSkin(item, type) {
      if (type == 'lucky') {
        this.setData.price = 0
        this.probability_min = 1
        if (this.setData.lucky_id == item.id) {
          this.setData.lucky_id = ''
          this.setData.lucky_data = {}
          return false
        }
        this.setData.price = item.price
        this.setData.lucky_id = item.id
        this.setData.lucky_data = item
      } else {
        this.setData.p_price = 0
        this.probability_min = 1
        if (this.setData.pack_id == item.id) {
          this.setData.pack_id = ''
          this.setData.pack_data = {}
          this.handleSearchLucky()
          return false
        }
        this.setData.p_price = item.price
        this.handleCommand()
        this.setData.pack_id = item.id
        this.setData.pack_data = item
      }
      // this.setData.probability = this.setData.probability + 10
      if (this.setData.p_price && this.setData.price) {
        let maxRate = this.setData.price >= 100 ? 0.5 : 0.65

        if (this.setData.price < this.setData.p_price * maxRate) {
          // 重置
          this.setData.price = 0
          this.probability_min = 1
          this.setData.lucky_id = ''
          this.setData.lucky_data = {}
        }

        let c = (this.setData.p_price / this.setData.price) > maxRate ? maxRate : (this.setData.p_price / this.setData.price)
        let rate = Math.round(c * 100)
        if (rate < 5) {
          this.setData.probability = 5
        } else if (rate > 75) {
          this.setData.probability = 75
        } else {
          this.setData.probability = rate
        }
        this.$forceUpdate()
      } else {
        this.setData.probability = 5
        this.$forceUpdate()
      }
    },
    // 计算价格
    jisPrice() {
      let sum = 0
      if (this.setData.lucky_id) {
        let maxRate = this.setData.price >= 100 ? 0.5 : 0.65
        // 最终总价
        let s1 = (this.setData.price * this.setData.probability) / 100
        // 抵扣
        let s2 = this.setData.price < (this.setData.p_price / maxRate) ? Math.round(this.setData.price * maxRate * 100) / 100 : this.setData.p_price * 1;
        sum = s1 - s2 > 0 ? s1 - s2 : 0
      }
      this.totalPrice = sum.toFixed(2)
      return sum.toFixed(2)
    },
    //音乐 结果
    playAlarm() {
      this.$refs.notify4.pause();
      this.$refs.notify.play();
    },
    handleUpgrade(id) {
      if (this.setData.lucky_id == '') {
        this.$message.warning('请先选择你想升级饰品!')
        return false
      }
      this.buyBox()
      // let str = ''
      // if (this.setData.pack_id == '') {
      //   str = `此次升级${this.setData.lucky_data.itemName}，此次消耗${this.totalPrice}，概率为${this.setData.probability}%是否继续操作。`
      // } else {
      //   str = `此次升级将把${this.setData.pack_data.name}升级成${this.setData.lucky_data.itemName}，此次消耗${this.totalPrice}，概率为${this.setData.probability}%是否继续操作。`
      // }
      // this.$confirm(str, '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.buyBox()
      // }).catch(() => {
      // })
    },
    //购买盲盒
    buyBox() {
      if (!this.$store.state.loginState) {
        this.$store.commit("getLogin", true);
        return;
      }

      this.isThree = window.innerWidth < 540
      this.disruptArr()
      this.loading = true
      let _this = this
      let param = {
        player_skin_id: this.setData.pack_id,
        skin_id: this.setData.lucky_id,
        probability: this.setData.probability,
      }
      // let res = {
      //   code: 200,
      //   msg: "恭喜中奖",
      //   data: {
      //     appId: 730,
      //     create_time: "2025-12-11 15:55:01",
      //     img: "http://47.94.52.130:9526/storage/csgo/skins/U2VhbGVkIEdyYWZmaXRpIHwgRGVhdGggU2VudGVuY2UgKEZyb2cgR3JlZW4p.png",
      //     itemId: "193349995",
      //     masonry: "15.98",
      //     name: "封装的涂鸦 | 死刑 (暗绿)",
      //     open_number: 22,
      //     open_number_md: "b6d767d2f8ed5d21a44b0e5886680cb9",
      //     order_num: "L20251215550196714044",
      //     player_id: 208,
      //     player_skin_id: 9614,
      //     price: "0.02",
      //     priceInfo: null,
      //     probability: 79,
      //     total_amount: "814863.59",
      //     type_id: "",
      //     way: 3,
      //   }
      // }
      // 数据结束
      this.$doPost("/api/hall.LuckySkin/upgradeSkin", param).then((res) => {
        this.$store.commit("getAboutMon", res.data)
        if (res.msg == "恭喜中奖" || res.msg == '升级成功') {
          this.winStatus = 2
          res.data.imageUrl = res.data.img
          this.openAnimList[40] = res.data
          this.winList = [res.data]
        } else {
          this.winStatus = 3
          this.noWin.name = res.data.presented + '钻'
          this.openAnimList[40] = this.noWin
          this.winList = [this.noWin]
        }
        if (this.cartState && this.voiceState) {
          this.$refs.notify4.currentTime = 0
          this.$refs.notify4.play()
        }
        //是否开启动画
        if (!this.cartState) {
          this.showWinState = true
          if (this.voiceState) {
            this.playAlarm()
          }
        } else {
          if (!this.voiceState) {
            this.isStartCart = true;
            setTimeout(() => {
              this.isStartCart = false;
              this.showWinState = true
              if (this.voiceState) {
                this.playAlarm()
              }
            }, 6500)
          }
        }
      }).catch(() => {
        this.loading = false
      })
    },
    onPlay() {
      console.log('开始播放音频')
      this.isStartCart = true
      console.log('播放动画')
      setTimeout(() => {
        this.isStartCart = false;
        this.showWinState = true
        if (this.voiceState) {
          this.playAlarm()
        }
      }, 6000 + 500)
    },
    handleAudioError() {
      this.isStartCart = true
      setTimeout(() => {
        this.isStartCart = false;
        this.showWinState = true
        if (this.voiceState) {
          this.playAlarm()
        }
      }, 6000 + 500)
    },
    //打乱滚动数据
    disruptArr() {
      this.openAnimList = []
      let numImg = parseInt((50 * this.setData.probability) / 100);
      if (numImg < 13) {
        numImg = 13;
      }
      for (let i = 0; i < 50; i++) {
        if (i < numImg) {
          this.openAnimList.push(this.setData.lucky_data)
        } else {
          this.openAnimList.push(this.noWin);
        }
      }
      this.openAnimList = this.getRandomArr(this.openAnimList, 50)
    },
    // 打乱数组
    getRandomArr(arr, num) {
      var _arr = arr.concat();
      var n = _arr.length;
      var result = [];

      // 先打乱数组
      while (n-- && num--) {
        var index = Math.floor(Math.random() * n); // 随机位置
        [_arr[index], _arr[n]] = [_arr[n], _arr[index]]; // 交换数据
        result.push(_arr[n]); // 取出当前最后的值，即刚才交换过来的值
      }
      return result;
    },
    //子组件修改父组件
    winexchange(msg) {
      this.setData.price = 0
      this.probability_min = 1
      this.setData.p_price = 0
      this.setData.pack_id = ''
      this.setData.pack_data = {}
      this.setData.lucky_id = ''
      this.setData.lucky_data = {}
      this.showWinState = false
      this.handleSearchLucky()
      this.getPackList()
    },
    goPage(ref) {
      console.log(window.innerWidth)
      window.scrollTo({
        top: 100,
        behavior: 'smooth'
      })
      let str = 'warehouse-box-pc'
      if (window.innerWidth < 767) {
        this.setData.showType = ref == 'pack' ? 'pack' : 'lucky'
        str = 'warehouse-box-mobile'
      }
      const element = this.$refs[str]
      if (element) {
        const elementPosition = element.getBoundingClientRect().top;
        // 2. 获取当前页面滚动距离
        const offsetPosition = elementPosition + window.pageYOffset;
        // 3. 设置偏移量 (例如头部高度为 80px，则减去 80)
        const headerHeight = 80; // 请根据实际头部高度调整此值

        window.scrollTo({
          top: offsetPosition - headerHeight,
          behavior: 'smooth'
        })
      }
      // this.$nextTick(() => {
      //   const element = this.$refs[str]; // 确保你的元素有一个ref="myElement"
      //   element.scrollIntoView({ behavior: 'smooth' })
      // })
    }
  },
};
</script>

<style lang="less" scoped>
.upgrade {
  .upgrade-top {
    background: url(~@/assets/images/upgrade/banner-bg.png);
    background-size: 100% 100%;
    background-repeat: repeat-y;
    background-position: 50%;
    position: relative;

    .back-box-w {
      padding: 20px 0 0;
    }

    .upgrade-skin-pc {
      padding: 40px 0;
    }

    .upgrade-skin {
      position: relative;
      font-size: 14px;
      color: #ffffff;
      text-align: center;

      .kedu {
        width: 370px;
        margin: 0 auto;

        .kedu-bg {
          width: 100%;
          position: relative;

          .ke-pan {
            width: 100%;
            height: auto;
          }

          .ke-pan-div {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            text-align: center;

            .line-img {
              width: auto;
              height: 50%;
              margin: 4px auto 0;
              // transform: rotate(300deg);
              transition: all 0.5s;
              transform-origin: 50% 100%;
            }

            .rate-p {
              font-weight: bold;
              font-size: 36px;
              color: #ffc400;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }

        .rate {
          margin: 16px 0;
        }

        .btn {
          max-width: 292px;
          line-height: 54px;
          border-radius: 8px 0 8px 0;
          border: 1px solid #fff;
          font-size: 16px;
          font-weight: bold;
          margin: 0 auto;
        }
      }

      .sel-skin {
        width: 435px;

        .skin-bg {
          position: relative;
          .skin-bg-img {
            width: 100%;
            height: auto;
          }
          .img-box {
            width: 80%;
            position: absolute;
            top: 0;
            left: 10%;

            img {
              width: 85%;
              height: auto;
            }
          }
        }
      }
    }
  }
  .audio {
    display: none;
  }
  .upgrade-content {
    padding-top: 30px;
    .warehouse-box {
      margin-top: 36px;
    }
    .warehouse-accessories {
      background: #1b1c20;
      width: calc(50% - 10px);

      .title {
        color: #ffffff;
        font-size: 14px;
        height: 72px;
        padding: 0 30px;
        border-bottom: 4px solid #3d3c3c;
        .t {
          font-size: 18px;
          color: #ffc400;
          font-weight: bold;
        }
        .title-wrap {
          margin: 20px 0;
          border: 1px solid #ffc400;
          height: 36px;
          border-radius: 4px;
          text-align: center;
          .title-item {
            font-weight: bold;
            line-height: 36px;
            height: 36px;
            cursor: pointer;
            padding: 0 15px;
            color: #ffffff;
            &.active-t {
              color: #000000;
              background: #ffc400;
              border-radius: 4px;
            }
          }
        }
      }
      .sel-form {
        text-align: right;
        width: calc(100% - 72px);
        .sel-form-input {
          width: 34%;
          vertical-align: middle;
        }
        .sel-form-input,
        .sel-form-select {
          ::v-deep .el-input__inner {
            height: 30px;
            line-height: 30px;
            color: #6a6a6a;
            border: 1px solid #6a6a6a;
            background-color: transparent;
          }
          ::v-deep .el-input__icon {
            line-height: 30px;
          }
        }
        .sel-form-select {
          width: 90px;
          margin-left: 10px;
          vertical-align: middle;
          ::v-deep .el-input__inner {
            padding: 0 10px;
          }
        }
        .sel-form-item {
          border-radius: 4px;
          border: 1px solid #6a6a6a;
          line-height: 30px;
          width: 60px;
          justify-content: center;
          cursor: pointer;
          font-size: 14px;
          color: #6a6a6a;
          margin-left: 10px;
          display: inline-block;
          text-align: center;
          vertical-align: middle;
        }
      }
      .acessories-box {
        // min-height: 969px;
        background: #1b1c20;
        .no-data {
          width: 100%;
          height: 969px;
          color: #ffffff;
          text-align: center;
          img {
            width: 138px;
            height: 153px;
          }
          .text {
            font-weight: bold;
            font-size: 24px;
            margin: 36px 0 18px;
          }
          .des {
            font-size: 15px;
            margin-bottom: 30px;
          }
          .btn {
            max-width: 292px;
            line-height: 54px;
            border-radius: 8px 0 8px 0;
            border: 1px solid #fff;
            font-size: 16px;
            font-weight: bold;
            margin: 0 auto;
          }
        }
      }
    }
    .warehouse-box-mobile {
      display: none;
      .acessories-box {
        padding: 0 15px;
      }
      .sel-form-mobile {
        display: none;
        padding: 15px 15px 7.5px;
        width: 100%;
        text-align: left;
        .sel-form-input {
          width: 40% !important;
        }
      }
    }
  }
}
.warehouse-box-pc .acessories-box {
  padding: 0 15px;
  box-sizing: border-box;
  .revisionSkin ul li {
    width: 25%;
  }
}
.el-slider-w {
  background: #000;
  padding: 15px 0;

  .el-slider-box {
    .slide-left {
      width: 70%;
      position: relative;
      .valText {
        position: absolute;
        bottom: -12px;
        color: #fff;
        padding: 0 4px;
        white-space: nowrap;
        transform: translateX(-50%);
        font-size: 15px;
        font-weight: bold;
      }
    }

    .btn-w-r-bg {
      width: 200px;

      .btn-c-r {
        line-height: 40px;
        height: 40px;
      }
    }
  }
}
.el-slider-box {
  ::v-deep .el-slider__runway {
    height: 20px;
    border-radius: 4px;
    background: linear-gradient(180deg, #73250b 0%, #a95017 100%);
    border: 2px solid #73250b;
  }

  ::v-deep .el-slider__bar {
    background: linear-gradient(0deg, #ffc400 0%, #fceda7 100%);
    height: 20px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  ::v-deep .el-slider__button-wrapper {
    z-index: 4;
    top: -8px;
    .el-slider__button {
      width: 22px;
      height: 34px;
      border: 0;
      background-color: transparent;
      border-radius: 0;
      background-image: url('~@/assets/images/upgrade/huojian.png');
      background-size: 100% 100%;
    }
  }
  ::v-deep .el-slider__marks-text {
    margin-top: -22px;
    color: #beb7b7;
  }
  ::v-deep .el-slider__stop {
    border-radius: 0;
    height: 10px;
    width: 2px;
    margin-top: 20px;
    background: #beb7b7;
  }
}
// 增加动画
.jTBQPZ {
  position: absolute;
  height: 40px;
  top: 50%;
  left: 50%;
  width: 58px;
  transform: translate(-50%, -50%) rotate(0deg);
}
.jTBQPB {
  transform: translate(-50%, -50%) rotate(180deg);
}
.jTBQPZ .arrow-icon {
  position: absolute;
  transform: scale(1);
  background-image: url(~@/assets/images/upgrade/arrow-mid-C1xhyQjy.webp);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 58px;
  height: 45px;
  left: 0;
  opacity: 0;
}
.jTBQPZ .arrow-icon:nth-child(1) {
  animation: 3s linear 1s infinite normal none running arrowScroll;
}
.jTBQPZ .arrow-icon:nth-child(2) {
  animation: 3s linear 2s infinite normal none running arrowScroll;
}
.jTBQPZ .arrow-icon:nth-child(3) {
  animation: 3s linear 0s infinite normal none running arrowScroll;
}
@keyframes arrowScroll {
  0% {
    opacity: 0;
    transform: translateY(66%) scale(0);
  }
  33% {
    opacity: 1;
    transform: translateY(33%) scale(1);
  }
  66% {
    opacity: 1;
    transform: translateY(0%) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateY(-33%) scale(0);
  }
}
</style>
